import React from 'react';
import PropTypes from 'prop-types';
import PanelGroup from 'react-bootstrap/lib/PanelGroup';
import Panel from 'react-bootstrap/lib/Panel';
import ProgressSpinner from '../../material/ProgressSpinner';

/** renders a mobile friendly view of a table list of data as an accordion */
export default class MobileAccordion extends React.Component {
  static propTypes = {
    /** adds additional className to each row's panel */
    className: PropTypes.string,
    /** array of data that will be rendered in he table */
    data: PropTypes.array.isRequired,
    /** define how the row data is rendered */
    fields: PropTypes.arrayOf(PropTypes.shape({
      /** overrides what is rendered as cell content
       *  (affects buth table and mobile version) */
      formatter: PropTypes.func,
      /** overrides what is rendered as cell content
       *  (only affects mobile version) */
      mobileFormatter: PropTypes.func,
      /** renders this row attribute as cell text */
      name: PropTypes.string,
      /** defines the column header */
      title: PropTypes.string
    })).isRequired,
    /** set to true when you want to display a loading icon */
    isLoadingData: PropTypes.bool,
    options: PropTypes.shape({
      /** use this attribute to render the row's title
       *  otherwise it uses the first field's name attribute */
      mobileTitleField: PropTypes.string,
      /** callback(event, row) when a row is clicked */
      onRowClick: PropTypes.func
    })
  };

  constructor(props){
    super(props);
    this.state = {};
  }

  renderFields = (dataRow, fields, titleField) => {
    return (
      fields.map((field) => {
        if (field.name === titleField){
          return null;
        } else if (field.mobileFormatter){
          return <div key={dataRow.id+field.name}>{field.mobileFormatter(dataRow[field.name], dataRow)}<br /></div>;
        } else if (field.formatter){
          return <div key={dataRow.id+field.name}>{field.title}: {field.formatter(dataRow[field.name], dataRow)}<br /></div>;
        } else {
          return <div key={dataRow.id+field.name}>{field.title}: {dataRow[field.name]}<br /></div>;
        }
      })
    );
  };

  renderRows = (data, fields) => {
    const { className, options = {} } = this.props
    const { mobileTitleField, onRowClick } = options;
    return (
      data.map((dataRow) => {
        const titleField = mobileTitleField || fields[0].name;
        return (
          <Panel key={dataRow.id} className={`mobile-accordion-data-list ${className}`} eventKey={dataRow.id}>
            <Panel.Heading>
              <Panel.Title toggle={true}>{dataRow[titleField]}</Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible={true}>
              {this.renderFields(dataRow, fields, titleField)}
              {onRowClick && <button onClick={(e) => onRowClick(e, dataRow)}>View</button>}
            </Panel.Body>
          </Panel>
        );
      })
    );
  };

  handleSelect = (activeKey) => {
    this.setState({ activeKey });
  };

  render() {
    const { isLoadingData } = this.props;
    if (isLoadingData){
      return <ProgressSpinner containerClassName="everfi-list-loader"/>;
    } else {
      return (
        <PanelGroup
          accordion={true}
          id="mobile-accordion"
          activeKey={this.state.activeKey}
          onSelect={this.handleSelect}>
          {this.renderRows(this.props.data, this.props.fields)}
        </PanelGroup>
      );
    }
  }
}
